export type TurnFlag = 'outfit' | 'product';

// Samma arbete annonseras med olika statusnycklar: den deterministiska vägen
// skickar sina egna, hjärnan sina. Hjärnan är den som kör i produktion — missas
// dess nycklar får turen varken skelettkort eller minnet av att den sökte.
const FLAG_BY_STATUS_KEY: Record<string, TurnFlag> = {
  'outfit.building': 'outfit',
  'ai.status.findingOutfit': 'outfit',
  'product.searching': 'product',
  'ai.status.searchingProducts': 'product',
};

export const turnFlagForStatusKey = (key: string): TurnFlag | null =>
  FLAG_BY_STATUS_KEY[key] ?? null;
